/**
 * Compile-time exhaustiveness check for a switch over a closed union — a
 * missed case fails to compile at the call site, independent of tsconfig's
 * noImplicitReturns (this project doesn't set it).
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled case: ${JSON.stringify(value)}`)
}
